import { initAll } from '~/src/client/javascripts/shared.js'

initAll()
